import { __awaiter, __generator, __read, __values } from "tslib";
import { isHydrated } from '../data-pointer';
import { createContext } from './query-job';
var QueryJobHydrate = /** @class */ (function () {
    function QueryJobHydrate(node, parent, transaction) {
        this.node = node;
        this.parent = parent;
        this.transaction = transaction;
        this.context = createContext(node);
    }
    QueryJobHydrate.prototype.perform = function (output) {
        return __awaiter(this, void 0, void 0, function () {
            var store, _loop_1, _a, _b, pointers, e_1_1;
            var e_1, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        store = this.transaction.table(this.node.collectionSchema.name);
                        _loop_1 = function (pointers) {
                            var nonePointers;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        nonePointers = pointers.filter(function (pointer) { return !isHydrated(pointer); });
                                        // request data at same time
                                        return [4 /*yield*/, Promise.all(nonePointers.map(function (_a, i) {
                                                var _b = __read(_a, 1), key = _b[0];
                                                return __awaiter(_this, void 0, void 0, function () {
                                                    var value;
                                                    return __generator(this, function (_c) {
                                                        switch (_c.label) {
                                                            case 0: return [4 /*yield*/, store.get(key)];
                                                            case 1:
                                                                value = (_c.sent());
                                                                // fill data
                                                                nonePointers[i][1] = value;
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                });
                                            }))];
                                    case 1:
                                        // request data at same time
                                        _e.sent();
                                        output.push(pointers);
                                        return [2 /*return*/];
                                }
                            });
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _a = __values(this.context.inputs), _b = _a.next();
                        _d.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        pointers = _b.value;
                        return [5 /*yield**/, _loop_1(pointers)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return QueryJobHydrate;
}());
export { QueryJobHydrate };
export default QueryJobHydrate;
//# sourceMappingURL=query-job-hydrate.js.map